(function () {

    'use strict';

    angular.module('app.search', []);

})();


// WEBPACK FOOTER //
// ./app/search/search.module.js